import type { TrialLinesReviewed } from './types';

// Minimum projected overage (percent over the Team allowance) before we treat
// volume as a meaningful signal. Shared by the on-card over-limit warning and the
// recommended_by_volume funnel flag so both use one definition of over the limit.
//
// Kept in this server-free module (no Prisma/next imports) so Client Components
// can import the threshold without pulling server-only code into the client bundle.
export const MIN_TEAM_OVER_LIMIT_PERCENT = 5;

export function getTeamOverLimitPercent(linesReviewed: TrialLinesReviewed): number {
  if (linesReviewed.teamMonthlyAllowance <= 0) {
    return 0;
  }

  return (
    ((linesReviewed.projectedMonthly - linesReviewed.teamMonthlyAllowance) /
      linesReviewed.teamMonthlyAllowance) *
    100
  );
}
